import React, {Fragment} from 'react'
import {connect} from "react-redux";
import {setSQFTActiveButton} from "../../../../actions/sqftMenuFunctions";
import {FormattedMessage, injectIntl} from "react-intl";
import {
  setSqftCroppedSlabImages,
  setActiveStep,
  setActiveSlabUrl, setSlabImageHeight, setSlabImageWidth, addSqftCroppedSlabImage, setIsSizeValidationFailed,
} from "../../../../actions/sqftSlabFunctions";

import {SLAB_IMAGE_TYPES} from "../../../../reducers/sqft/sqftSlabReducer";
import sqftShapeManager from "../canvas/store/sqftShapeManager";
import sqftConfig from "../canvas/store/sqftConfig";
import imageCompression from 'browser-image-compression';

const SqftLoadSlabFooterSelectImageTypeButtons = (props) => {
  const {setSQFTActiveButton, setIsSizeValidationFailed, setActiveSlabUrl, setActiveStep} = props;
  const {slabImageType} = props;
  const {slabImageWidth, slabImageHeight} = props;
  const {activeStep} = props;

  const closePopup = () => {
    setSQFTActiveButton("");
  }

  const addPlaceholderShape = () => {
    sqftShapeManager.addPlaceholderShape(
      +slabImageWidth / sqftConfig.getMeasureMultiplier(),
      +slabImageHeight / sqftConfig.getMeasureMultiplier(),
    );
  }

  const handlePlaceholderClick = () => {
    if (!slabImageWidth || !slabImageHeight) {
      setIsSizeValidationFailed(true);
      return
    }

    setIsSizeValidationFailed(false);
    addPlaceholderShape();
    closePopup();
  }

  const onImageUploadChange = (event) => {
    let options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true
    }
    const imageFile = event.target.files[0];
    imageCompression(imageFile, options)
      .then(compressedFile => {
        console.log('compressedFile instanceof Blob', compressedFile instanceof Blob);
        console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`);
        let domString = URL.createObjectURL(compressedFile);
        setActiveSlabUrl(domString);
        setActiveStep(1);
      });
  };

  return (
    <Fragment>
      {
        activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.placeholder ?
          <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes"
                  onClick={() => {handlePlaceholderClick()}}>
              <span className="ui-button10-text ui-button10--uppercase">
                <FormattedMessage id={"sqft.popup.slabmode.upload"}/>
              </span>
          </button>
          : null
      }
      {
        activeStep === 0 && slabImageType === SLAB_IMAGE_TYPES.upload  ?
          <button className="ui-button10 ui-button10--green meta-buttons-confirm-nav--yes">
            <label className="slab-header__library-upload">
              <input type="file" onChange={onImageUploadChange} />
              <FormattedMessage id={"sqft.popup.slabmode.upload"}/>
            </label>
          </button>
          : null
      }
    </Fragment>

  )
};

const mapStateToProps = (store) => ({
  activeSlabId: store.sqftSlabState.activeSlabId,
  activeStep: store.sqftSlabState.activeStep,
  slabImageWidth: store.sqftSlabState.slabImageWidth,
  slabImageHeight: store.sqftSlabState.slabImageHeight,
  pricePerArea: store.sqftSlabState.pricePerArea,
  activeButton: store.sqftMenuState.activeButton,
  slabImageType: store.sqftSlabState.slabImageType,
});

const mapDispatchToProps = {
  setSQFTActiveButton,
  setActiveStep,
  setActiveSlabUrl,
  setSqftCroppedSlabImages,
  setSlabImageHeight,
  setSlabImageWidth,
  addSqftCroppedSlabImage,
  setIsSizeValidationFailed,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftLoadSlabFooterSelectImageTypeButtons)
)
